import { http } from '@/core/helpers/http.helper';
import { Communication } from '../../communications/communication.interface';
import { CustomerAddress } from '../customer.interface';
import { ApiResource } from './../../../models/api-resource.interface';

export class AddressService {
   async postAddress(customerId: number, address: CustomerAddress) {
      const response = await http.post<ApiResource<CustomerAddress>>(`/customer/${customerId}/addresses`, address);
      return response.data;
   }
   async putAddress(customerId: number, addressId: number, address: CustomerAddress) {
      const response = await http.put<ApiResource<CustomerAddress>>(`/customer/${customerId}/addresses/${addressId}`, address);
      return response.data;
   }
   async call(customerId: number, addressId: number, hitId?: number) {
      const response = await http.get<ApiResource<Communication>>(
         `/customers/${customerId}/addresses/${addressId}/call${hitId ? '/' + hitId : ''}`,
      );
      return response.data;
   }
   async inviteToVideoRoom(customerId: number, videocallRoomId: number, addressId: number) {
      const response = await http.get<ApiResource<Communication>>(
         `/customers/${customerId}/addresses/${addressId}/video-room/${videocallRoomId}/invite`,
      );
      return response.data;
   }
}
